export enum TableNode {
    Table = 'table',
    Head = 'thead',
    Body = 'tbody',
    Row = 'tr',
    HeaderCell = 'th',
    DataCell = 'td',
}

export enum TableAttrs {
    CellAlign = 'cell-align',
}

export enum CellAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
